import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';

class SignupBox extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      email: '',
      disabled: false
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }
  handleSubmit() {
    // console.log('call revue', this.state.email);
    const savedEmail = this.state.email;
    const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const emailStatus = emailRegex.test(savedEmail);
    const data = {
      email: savedEmail,
      first_name: 'new',
      last_name: 'user',
      double_opt_in: false
    };

    if (emailStatus) {
      const webApiUrl = 'https://tempo.inc.com/getrevue/add';
      const tokenStr = 'iHKTPKgaDUSYFKnbsZlEnbPT119pM-3e';
      axios
        .post(webApiUrl, data, {
          headers: {
            Authorization: `Token ${tokenStr}`
          }
        })
        .then(response => {
          // console.log(response);
          if (response.status === 200) {
            this.setState({
              disabled: true,
              email: "You're Subscribed!"
            });
          }

          let el = document.querySelector('.__dek');
          el.style.display = 'none';
          el = document.querySelector('.__input-div');
          el.style.display = 'none';
          el = document.querySelector('.__thank-you');
          el.style.display = 'block';
        })
        .catch(err => {
          this.setState({
            disabled: false,
            email: ''
          });
          const placeholder =
            err.response.data.error.email[0] ===
            'This email address has already been subscribed'
              ? 'Already subscribed'
              : err.response.data.error.email[0];
          let el = document.querySelector('.__email-input');
          el.placeholder = placeholder;
          el = document.querySelector('.__input-div');
          el.className = '__input-div __input-div--error';
        });
    } else {
      this.setState({
        disabled: false,
        email: ''
      });
      const placeholder = 'Please enter a valid email';
      let el = document.querySelector('.__email-input');
      el.placeholder = placeholder;
      el = document.querySelector('.__input-div');
      el.className = '__input-div __input-div--error';
    }
  }

  handleKeyPress(event) {
    if (event.which === 13) {
      const el = document.querySelector('.__email-input');
      el.blur();
      this.handleSubmit();
    }
  }

  render() {
    return (
      <center>
        <div className="signup-box">
          <div className="__box-left">
            <img
              alt="compass_logo"
              className="__desktop"
              src="https://images.fastcompany.net/image/upload/v1556587129/fcweb/fc_compass_big_n6v2nh.png"
            />
            <img
              alt="compass_logo"
              className="__mobile"
              src="https://images.fastcompany.net/image/upload/v1559074510/fcweb/DailyCompass_compass_RGB_outlines_yn4acq.svg"
            />
          </div>
          <div className="__box-right">
            <span className="__thank-you">Thank you for signing up!</span>
            <span className="__dek">
              <b className="heading">Navigate smart.</b> Sign up for our daily
              email.
            </span>
            <div className="__input-div">
              <input
                className="__email-input"
                type="text"
                onChange={e => {
                  this.setState({ email: e.target.value }, () => {
                    // console.log(this.state.email);
                  });
                  const el = document.querySelector('.__input-div');
                  el.className = '__input-div';
                }}
                onKeyPress={this.handleKeyPress}
                value={this.state.email}
                placeholder="Enter your email address"
                disabled={this.state.disabled ? 'disabled' : ''}
              />
              <button
                className="__button"
                type="submit"
                value="SUBMIT"
                name="button"
                onClick={this.handleSubmit}
                disabled={this.state.disabled ? 'disabled' : ''}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      </center>
    );
  }
}

// SignupBox.propTypes = {
//   name: PropTypes.string.isRequired,
//   desc: PropTypes.string.isRequired,
//   lists: PropTypes.arrayOf(PropTypes.number).isRequired,
//   choices: PropTypes.arrayOf(PropTypes.string),
//   checked: PropTypes.arrayOf(PropTypes.bool).isRequired,
//   onChange: PropTypes.func.isRequired,
//   handleNewslettersRadioUpdate: PropTypes.func,
//   isRadio: PropTypes.bool
// };

function mapStateToProps(state) {
  return {
    config: state.config,
    currentSite: state.config.site
    // assignedNewsletters: assignedNewsletters.map(
    //   function processAssignedNewsletters(newsletter) {
    //     const newsletterNameProp = newsletter.list;
    //     const listId = get(newslettersBySlug, newsletterNameProp);
    //     const found = newsletterDictionary[listId];
    //     return {
    //       listName: get(found, 'listName'),
    //       listId,
    //       message: get(found, 'short')
    //     };
    //   }
    // )
  };
}

export default connect(mapStateToProps)(SignupBox);
